"use strict";

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 * @format
 * 
 */
var Banzai = {
  post: function post(name, data, options) {}
};
module.exports = Banzai;